<ng-container
  *ngIf="{
    data: (displayedData$ | async),
    isFocus: (isFocus$ | async)
  } as streams$"
>
  <int-labeled-field-box
    #box
    intNativeElement
    [isActive]="isActive"
    [isFocus]="streams$.isFocus || isShow || false"
    [label]="placeholder"
    (click)="onContainerClick()"
  >
    <ng-container ngProjectAs="left-position">
      <ng-content select="left-position"></ng-content>
    </ng-container>
    <ng-container ngProjectAs="center-position">
      <ng-container>
        <input
          readonly
          class="_field"
          type="text" [value]="streams$.data"
          (focus)="onFocus()"
          (blur)="onBlur()"
        >
      </ng-container>
    </ng-container>
    <ng-container ngProjectAs="right-position">
      <div class="clear-wrap" *ngIf="clearable">
        <int-clear-action-default (onClear)="onClear($event)"></int-clear-action-default>
      </div>
    </ng-container>
    <ng-content select="right-position"></ng-content>
  </int-labeled-field-box>

  <int-portal-slot
    [targetRef]="box.elementRef.nativeElement"
    [show]="isShow || streams$.isFocus"
    [satellitePayload]="{customDropWidth: 280, horizontalAlign: 'start'}"
  >
    <ng-template intPortalSlotTemplate>
      <int-dropdown-area
        class="portal-element"
        [excludeElementsForClickOutside]="box.elementRef.nativeElement"
        (clickOutside)="clickOutSide()"
      >
        <int-calendar
          [currentDate]="date"
          [type]="type"
          (onChange)="onCalendarChange($event)"
        ></int-calendar>
      </int-dropdown-area>
    </ng-template>
  </int-portal-slot>
</ng-container>

